
var stache = require('can/view/stache/stache');
module.exports = stache("<div class=\"{{className}}\">\r\n    <div>{{firstCharStr slideOptions.firstName}}. {{slideOptions.lastName}}</div>\r\n</div>");